import React from 'react';
import {
  Box,
  Flex,
  Text,
  HStack,
  Avatar,
  AvatarGroup,
  Button,
  Spacer,
} from '@chakra-ui/react';
import { FiPlus } from 'react-icons/fi';
import GlobalInventoryFilter from "./Components/GlobalInventoryFilter";
import AddProductButtonModal from "./Components/AddProductButtonModal";

const Header = ({ users, onFilter, onSearch, filterLoading }) => {
  return (
    <Box bg="white" borderBottom="1px" borderColor="#DFE1E6" px={6} py={3} shadow="sm">
      <Flex align="center">
        <Text fontSize="20px" fontWeight="600" color="#172B4D">
          Design Inventory
        </Text>

        <Spacer />

        <HStack spacing={4} align="center">
          <AvatarGroup size="sm" max={5} spacing="-8px">
            {(users || []).map((user) => (
              <Avatar
                key={user.id}
                src={user.avatar}
                name={user.name}
                w="32px"
                h="32px"
                border="2px solid white"
              />
            ))}
          </AvatarGroup>

          {/* Global Filter */}
          <GlobalInventoryFilter
            onFilter={onFilter}
            onSearch={onSearch}
            loading={filterLoading}
          />

          {/* Add Product Button + Drawer Component */}
          <AddProductButtonModal />
        </HStack>
      </Flex>
    </Box>
  );
};

export default Header;
